/**
 * Emergent Auth — client helpers.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
 * THIS BREAKS THE AUTH. Always derive the redirect from `window.location.origin`.
 */

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Kick off the Google sign-in flow. The user will be sent to Emergent's
 * hosted auth page and returned to `${window.location.origin}${returnTo}`
 * with `#session_id=…` in the URL fragment for the AuthCallback route.
 */
export function startGoogleLogin(returnTo = "/university") {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
  // THIS BREAKS THE AUTH.
  const redirectUrl = window.location.origin + returnTo;
  window.location.href =
    "https://auth.emergentagent.com/?redirect=" +
    encodeURIComponent(redirectUrl);
}

/** Ask the backend who the current user is (cookie-based). */
export async function fetchMe() {
  const res = await fetch(`${API}/api/auth/me`, {
    credentials: "include",
  });
  if (!res.ok) return null;
  return res.json();
}

/** Exchange the one-time session_id (from the URL fragment) for a persistent
 *  server-side session + httpOnly cookie. Returns the authenticated user. */
export async function exchangeSession(sessionId) {
  const res = await fetch(`${API}/api/auth/session`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ session_id: sessionId }),
  });
  if (!res.ok) throw new Error(`Session exchange failed (${res.status})`);
  return res.json();
}

export async function logout() {
  await fetch(`${API}/api/auth/logout`, {
    method: "POST",
    credentials: "include",
  });
}
